import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { TimePicker } from 'antd'

export const FooterFlex = styled(Flex)`
  gap: 15px;
`
export const HeaderFlex = styled(Flex)`
  margin: 8px 0;
`
export const TotalTimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: ${props => !props?.height && '8px'};
`
export const StartSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_60)};
`
export const TimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  text-align: right;
  color: ${COLORS.GREY_T_60};
`
export const TimeFlex = styled(Flex)`
  padding: 12px 13px;
  width: 100%;
  height: 48px;
  background: ${COLORS.PRIMARY_GREY_T_98};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  margin-bottom: 20px;
`
export const TimeInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  color: ${COLORS.GREY_P_100};
`
export const BreakDiv = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #1b1f22;
  margin-bottom: 10px;
`

export const LabelDiv = styled.div`
  margin-top: 8px;
`

export const Inputdiv = styled.div`
  margin: 8px 0 20px 0;
`
export const SessionFlex = styled(Flex)`
  gap: 15px;
`

export const TimeStyles = styled(TimePicker.RangePicker)`
  width: ${props => (props.width ? props.width : '100%')};
  height: 48px !important;
  padding: 10px 20px;
  background: ${COLORS.PRIMARY_GREY_T_98};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 8px;
  line-height: 24px;
  &:focus {
    outline: none;
    opacity: 1;
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
    background-color: ${COLORS.WHITE};
  }
  &:focus::placeholder {
    color: transparent;
  }
  &::placeholder {
    opacity: 0.4;
  }
  &:hover {
    border: 1px solid ${COLORS.GREY_T_90};
  }
  .ant-picker-input > input {
    font-size: 1.1428571428571428em;
    font-weight: ${FONT.FW_500};
  }
  .ant-btn-primary {
    border-radius: 8px !important;
    height: 38px !important;
  }
`

export const IconWrapper = styled.div`
  padding-top: 135%;
  cursor: pointer;
`
